<script lang="ts">
  import { formatCurrency } from "$lib/util/format";

	export let groups: { items: {id:number, name:string, price:number }[] }[] = [];
	export let groupType: 'addon' | 'extra' | 'option' | 'addon-extra' | 'addon-option';
</script>

{#if groups?.length}
	{#each groups as group}
		{#each group.items as item}
			<div class="basis-50 label-l book medium-importance m-0" data-testid={`${groupType}-name`}>{item.name}</div>
			{#if item.price}
				<div class="text-right label-l book medium-importance m-0" data-testid={`${groupType}-price`}>{formatCurrency(item.price)}</div>
			{:else}
				<span data-testid={`${groupType}-price`}>--</span>
			{/if}
		{/each}
	{/each}
{/if}
